import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { api, tokenStore } from '../api-client';

export default function Login() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  // ?token=... 経由のアクセスで自動検証
  useEffect(() => {
    const token = params.get('token');
    if (!token) return;
    (async () => {
      try {
        setLoading(true);
        const result = await api.verifyToken(token);
        tokenStore.set(result.token);
        navigate('/');
      } catch (e) {
        setError((e as Error).message);
      } finally {
        setLoading(false);
      }
    })();
  }, [params, navigate]);

  async function handleSend(e: React.FormEvent) {
    e.preventDefault();
    setError(null);
    setLoading(true);
    try {
      await api.requestMagicLink(email);
      setSent(true);
    } catch (e) {
      setError((e as Error).message);
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="min-h-[80vh] flex items-center justify-center">
      <div className="bg-white p-8 rounded-lg shadow border max-w-md w-full">
        <h2 className="text-2xl font-bold mb-2">Cogneolink にログイン</h2>
        <p className="text-sm text-slate-600 mb-6">
          メールアドレスにログインリンクをお送りします
        </p>

        {sent ? (
          <div className="bg-green-50 p-4 rounded border border-green-200">
            <p className="text-green-800 text-sm">
              ✓ {email} にログインリンクを送信しました
            </p>
            <p className="text-xs text-slate-500 mt-2">
              メールが届かない場合は support@cogneolink.jp までご連絡ください
            </p>
            <p className="text-xs text-slate-500 mt-2">リンクは15分有効です</p>
          </div>
        ) : (
          <form onSubmit={handleSend} className="space-y-4">
            <div>
              <label className="block text-sm font-medium mb-1">メールアドレス</label>
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="your@example.com"
                className="w-full px-3 py-2 border rounded"
              />
            </div>
            {error && <p className="text-red-600 text-sm">{error}</p>}
            <button
              type="submit"
              disabled={loading}
              className="w-full bg-blue-600 text-white py-2 rounded hover:bg-blue-700 disabled:opacity-50"
            >
              {loading ? '送信中...' : 'ログインリンクを送る'}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
